<template>
  <div>
    <el-dialog
        title="Thêm tài khoản ngân hàng"
        :before-close="handleClose"
        :visible.sync="isAddAccountDialog"
        :show-close="true"
        :close-on-click-modal="false"
        width="700px"
        top="20vh"
        @open="handleOpen"
    >
      <el-form
          label-width="140px"
          :model="formData"
          label-position="left"
          :rules="rules"
          ref="formData"
      >
        <el-form-item label="Chọn ngân hàng" prop="brandName">
          <el-select v-model="formData.brandName" placeholder="Chọn ngân hàng" style="width: 500px">
            <el-option
                v-for="item in banks"
                :key="item.code"
                :label="item.full_name + ' - ' + item.brand_name"
                :value="item.brand_name"
            >
              <div style="display: flex; align-items: center;">
                <img :src="item.logo_path" alt="logo" style="width: 24px; height: 24px; margin-right: 8px;"/>
                <span>{{ item.full_name }} - {{ item.brand_name }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Tên chủ tài khoản" prop="account_holder_name">
          <el-input v-model="formData.account_holder_name" placeholder="Nhập tên chủ tài khoản"
                    style="width: 500px"></el-input>
        </el-form-item>
        <el-form-item label="Số tài khoản" prop="account_number">
          <el-input v-model="formData.account_number" placeholder="Nhập số tài khoản" style="width: 500px" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="Số CMND/CCCD" prop="identification_number">
          <el-input v-model="formData.identification_number" placeholder="Nhập số CMND/CCCD" maxlength="100" show-word-limit
                    style="width: 500px"></el-input>
        </el-form-item>
        <el-form-item label="Số điện thoại" prop="phone_number">
          <el-input v-model="formData.phone_number" placeholder="Nhập số điện thoại" style="width: 500px" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="Tên gợi nhớ" prop="label">
          <el-input v-model="formData.label" placeholder="Nhập tên gợi nhớ" style="width: 500px"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
          <el-button
                type="danger"
                size="medium"
                @click="handleClose"
            >
              <i class="el-icon-circle-close"/>
        <span>Đóng</span>
         </el-button>
         <el-button
             type="primary"
             size="medium"
             :disabled="formData.brand_name === ''"
             :loading="loading.submit"
             mini
             @click="submitForm()"
         >
        <i class="el-icon-circle-check"/>
        <span>Tiếp tục</span>
      </el-button>
    </span>
    </el-dialog>
    <div>
      <TermsOfUseDialog
          :bank="formData"
          :isTermsOfUseDialog="isTermsOfUseDialog"
          @closeDialog="handleClose"
      />
    </div>
  </div>
</template>

<script>

import sePayConnectionService from "@/services/SePayConnectionService";
import TermsOfUseDialog from "@/views/sepay/dialog/TermsOfUseDialog.vue";

export default {
  name: "AddAccountBankDialog",
  components: {TermsOfUseDialog},
  props: {
    isAddAccountDialog: {
      type: Boolean,
      default: () => false
    },
  },

  data() {
    return {
      bank: {},
      formData: {
        brandName: "",
        account_holder_name: "",
        account_number: "",
        identification_number: "",
        phone_number: "",
        label: "",
      },
      banks: [],
      rules: {
        brandName: [
          {
            required: true,
            message: "Ngân hàng không được để trống!",
            trigger: "change",
          },
          // {max: 200, message: 'Tối đa 200 ký tự', trigger: 'change'}
        ],
        account_holder_name: [
          {
            required: true,
            message: "Tên chủ tài khoản không được để trống",
            trigger: "change",
          },
          {
            pattern: /^[A-Z0-9 ]*$/,
            message: 'Chỉ cho phép chữ in hoa (A-Z), số (0-9) và dấu cách',
            trigger: 'change',
          }
        ],
        account_number: [
          {
            required: true,
            message: "Số tài khoản không được để trống",
            trigger: "change",
          },
          {max: 20, message: 'Tối đa 20 ký tự', trigger: 'change'},
        ],
        phone_number: [
          {
            required: true,
            message: "Số điện thoại không được để trống",
            trigger: "change",
          },
          {max: 10, message: 'Tối đa 10 ký tự', trigger: 'change'},
          {
            pattern: /^[0-9]*$/,
            message: 'Chỉ cho phép số 0-9',
            trigger: 'change',
          }
        ],
        identification_number: [
          {
            required: true,
            message: "Số CMND/CCCD không được để trống",
            trigger: "change",
          },
          {max: 100, message: 'Tối đa 100 ký tự', trigger: 'change'},
        ],
      },
      isTermsOfUseDialog: false,
      loading: {
        submit: false,
      },
    }
  },

  methods: {
    handleClose() {
      this.isTermsOfUseDialog = false
      this.$refs["formData"].resetFields();
      this.$emit("closeDialog");
    },
    handleOpen() {
      this.findListBankSupport()
    },
    async findListBankSupport() {
      await sePayConnectionService.getSePayConnectionServiceSupportToPlus().then((response) => {
        if (response.data.status === 200) {
          this.banks = response.data.data.data;
        }
      })
    },
    async submitForm() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
         this.formData.idBank = this.bank.id
         this.formData.brand_name = this.bank.brand_name
          this.isTermsOfUseDialog = true
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>